import { AppButton, AppButtonRow, AppCard, AppCardBody, AppText } from '../../ui-foundation';

interface ActionPackButton {
  label: string;
  onClick: () => void;
  primary?: boolean;
}

interface ActionPackCardProps {
  icon: string;
  eyebrow: string;
  title: string;
  description: string;
  steps: string[];
  actions: ActionPackButton[];
}

export default function ActionPackCard({
  icon,
  eyebrow,
  title,
  description,
  steps,
  actions,
}: ActionPackCardProps) {
  return (
    <AppCard>
      <div className="flex items-start gap-3">
        <span className="text-xl shrink-0">{icon}</span>
        <div className="min-w-0 flex-1">
          <AppText fontSize="$xs" fontWeight="700" textTransform="uppercase" letterSpacing={0.8} color="$colorMuted">
            {eyebrow}
          </AppText>
          <AppText className="mt-1" fontSize="$sm" fontWeight="700">{title}</AppText>
          <AppText className="mt-2" fontSize="$sm" color="$colorMuted">{description}</AppText>
        </div>
      </div>

      <AppCardBody className="mt-4">
        {steps.map((step) => (
          <div key={step} className="flex items-start gap-2 rounded-xl border border-border bg-background px-3 py-2.5">
            <span className="mt-0.5 text-[11px] font-semibold text-primary">•</span>
            <AppText fontSize="$sm">{step}</AppText>
          </div>
        ))}
      </AppCardBody>

      <AppButtonRow mt="$md">
        {actions.map((action) => (
          <AppButton
            key={action.label}
            size="sm"
            tone={action.primary ? 'primary' : 'outline'}
            onPress={action.onClick}
          >
            {action.label}
          </AppButton>
        ))}
      </AppButtonRow>
    </AppCard>
  );
}
